import React from "react";
import { Box } from "@mui/material";
import IncidentContent from "../../components/OperationDashboard/TabContent/IncidentContent";

const IncidentReport = () => {
  return (
    <Box sx={{ p: 2 }}>
      <IncidentContent />
    </Box>
  );
};

export default IncidentReport;